import { createFileRoute } from "@tanstack/react-router";
import { SignIn } from "@clerk/react";

// Clerk's sign-in, including its "choose a salon" step (/sign-in/tasks/choose-organization) when the user has no
// active salon. Clerk sends signed-in users on, and returns to `redirect_url` after signing in.
export const Route = createFileRoute("/sign-in/$")({
  component: () => (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <SignIn routing="path" path="/sign-in" />
    </div>
  ),
});
